import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { colors } from '_styles';
import { _ } from '_locales';
import moment from 'moment';
import apis from '_apis';
import cts from '_cts';
import HOC from '_HOC';

import { InfoIcon, Loader } from '../components';
import * as actions from '../redux/actions';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Title = styled.h2`
    font-size: 20px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    color: #000;
    text-align: left;
`;

const Content = styled.p`
    font-size: 16px;
    color: #747474;
    line-height: 1.8em;
    margin-bottom: 65px;
`;

const Exit = styled.button`
    border: none;
    margin: 0 auto;
    display: block;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer !important;
    color: ${colors.RC_ACTION};
    background-color: transparent;
    margin-bottom: 5px;
    text-decoration: underline;
`;

const IncorrectBtn = styled.button`
    border: none;
    background-color: transparent;
    margin: 0 auto;
    display: flex;
    cursor: pointer !important;
`;

const IncorrectIconContainer = styled.div`
  flex: 1;
  padding-top: 10px;
`;

const IncorrectText = styled.p`
    color: ${colors.RC_LIGHT_RED};
    font-size: 14px;
    font-weight: 600;
    margin: 10px 5px;
`;

const NotScheduledForToday = ({
  zone, plugin, config, setFromHelp, props
}) => {
  const { zoneStr } = zone;
  const { projectId } = plugin;
  const { districtId } = config;
  const { location, history } = props;
  const { collId, title } = location.state;

  const [date, setDate] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data, status } = await cts('get', apis.getNextPickUp(projectId, districtId, zoneStr, collId));

        if (
          !data
          || !Object.keys(data).length
          || status !== 200
          || (
            Object.keys(data).length
            && !data.date
          )
        ) throw setDate('');

        setLoading(false);
        setDate(`${moment(data.date).format('dddd')}, ${moment(data.date).format('MMMM D, YYYY')}`);
      } catch (e) {
        setLoading(false);
        setError(true);
        console.warn('There was a problem in getting next pick-up schedule, at NotScheduleForToday section.');
      }
    })();
  }, []);

  return (
    <Container>
      {
        loading ? (<Loader />) : (
          <>
            <Title>{_('help.not_schedule_for_today')}</Title>
            <Content>
              {title}
              {' '}
              {_('help.was_not_scheduled_for_today')}
              {
                !error && (
                  <>
                    {' '}
                    {_('help.next_pick_up_is')}
                    {' '}
                    {date || ''}
                  </>
                )
              }
            </Content>
            <Exit onClick={() => history.push('/help')}>{_('reminder.exit')}</Exit>

            <IncorrectBtn>
              <IncorrectIconContainer>
                <InfoIcon />
              </IncorrectIconContainer>

              <IncorrectText
                onClick={() => [setFromHelp(true), history.push('/help/form-page', {
                  type: 'MISSED_PICKUP',
                  title: _('help.report_an_incorrect_pick_up_schedule'),
                  description: `${_('help.collection_type')} ${title}`,
                  formDesc: _('help.i_want_to_report_an_incorrect_schedule', { type: title })
                })]}
              >
                {_('help.report_an_incorrect_pick_up_schedule')}
              </IncorrectText>
            </IncorrectBtn>
          </>
        )
      }
    </Container>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setFromHelp: (fromHelp) => dispatch(actions.setFromHelp(fromHelp)),
});

export default HOC(connect(null, mapDispatchToProps)(NotScheduledForToday));
